module.exports = __webpack_public_path__ + "img/close.ab2e7b01.svg";